// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import subscribeHubspotForm from "@west/App/SharedStyles/Subscribe/subscribeHubspotForm";
import { subscribeStyles } from "@west/Overrides/Widgets/Basic/Subscribe";
import buttonStyle from "@west/XDL/PreStyle/button";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 0,
    offsetCss: css`
        align-items: flex-start;
    `,
    css: css`
        width: 100%;
        display: flex;
        & > ${GridOffset} {
            flex-direction: column;
            flex-wrap: nowrap;
            gap: 12px;
        }
    `,
};

subscribeStyles.titleGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

subscribeStyles.titleLabel = {
    variant: "h6",
    forwardAs: "p",
    color: "common.white",
    css: css`
        &,
        & > ${TypographyStyle} {
            margin-bottom: 4px;
        }
    `,
};

subscribeStyles.descriptionText = {
    css: css`
        &,
        & > ${TypographyStyle} {
            font-size: 12px;
            line-height: 20px;
            color: ${color("common.white")};
            margin-bottom: 0;
        }
    `,
};

subscribeStyles.emailGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        align-items: center;
        border: 1px solid ${color("common.ui5")};
        background-color: ${color("common.ui16")};
        box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
        padding-right: 3px;
        width: 100%;
    `,
};

subscribeStyles.emailTextField = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            margin-right: 10px;

            &&& input {
                &,
                &:hover,
                &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]):not([class^="PopoverTriggerInput"]):hover:not(:disabled),
                &:focus {
                    border: none;
                    box-shadow: none;
                }
                &::-webkit-input-placeholder {
                    color: ${color("common.ui4")};
                }
            }
        `,
        descriptionWrapper: css`
            position: absolute;
        `,
    },
};

subscribeStyles.infoGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

subscribeStyles.emailButton = {
    color: "common.ui8",
    sizeVariant: "small",
    typographyProps: {
        size: 12,
        lineHeight: "12px",
        color: "common.white",
    },
};

subscribeStyles.externalProviderGridItem = {
    width: 12,
    css: css`
        width: 100%;

        ${subscribeHubspotForm}
    `,
};
